var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBloquer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M405.333 179.712V149.333C405.333 66.859 338.475 0 256 0C173.525 0 106.667 66.859 106.667 149.333V179.712C67.841 196.657 42.723 234.971 42.667 277.333V405.333C42.737 464.214 90.452 511.93 149.333 512H362.666C421.547 511.93 469.262 464.214 469.333 405.333V277.333C469.278 234.971 444.159 196.657 405.333 179.712ZM277.333 362.667C277.333 374.449 267.782 384 256 384C244.218 384 234.667 374.449 234.667 362.667V320C234.667 308.218 244.218 298.667 256 298.667C267.782 298.667 277.333 308.218 277.333 320V362.667ZM362.667 170.667H149.333V149.334C149.333 90.424 197.089 42.667 256 42.667C314.911 42.667 362.667 90.423 362.667 149.334V170.667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloquer);
export default __webpack_public_path__ + "static/media/bloquer.15c1a1a6c89bae82f2880cc6c473fb69.svg";
export { ForwardRef as ReactComponent };